export const X_VIEWER_KEY = 'kouch-x-viewer-id';
export const X_VIEWER_OPTIONS = {
	path: '/',
	maxAge: 1000 * 60 * 60 * 24 * 365, // 1 year
};
